// NewsTicker.js — barre de news DÉFILANTE (marquee) de l'écosystème VertinGo.
// Source : /news (fil curé publié par l'agent de prod) — events spéciaux, nouvelles vidéos/
// articles, nouveaux jeux, grosses perfs. Se masque proprement s'il n'y a rien à annoncer.
import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../theme';
import { fetchNews } from '../services/api';

// Anti-liens locaux : un fil curé peut contenir de vieilles URLs (localhost/docker.devhost) → non cliquable.
const cleanUrl = (u) => (typeof u === 'string' && !/localhost|127\.0\.0\.1|docker\.devhost/i.test(u) ? u : undefined);

const scroll = keyframes`from{transform:translateX(0)} to{transform:translateX(-50%)}`;

const Bar = styled.div`
  display: flex; align-items: center; gap: .6rem;
  background: linear-gradient(135deg,#0d0d1a,#241a3d);
  border-bottom: 1px solid ${theme.colors.border};
  color: #fff; overflow: hidden; white-space: nowrap;
  padding: 0 .4rem 0 0; height: 34px; font-size: .84rem;
  /* juste SOUS la toolbar fixe (64px), pleine largeur */
  position: fixed; top: 64px; left: 0; right: 0; z-index: 900;
`;
const Label = styled.span`
  flex: none; display: inline-flex; align-items: center; gap: .35rem;
  background: linear-gradient(135deg,${theme.colors.primary},${theme.colors.secondary});
  color: #fff; font-weight: 800; letter-spacing: .05em; font-size: .68rem;
  padding: 0 .7rem; height: 100%; text-transform: uppercase;
  .dot{width:7px;height:7px;border-radius:50%;background:#fff;animation:vgpulse 1.6s infinite}
  @keyframes vgpulse{0%,100%{opacity:1}50%{opacity:.35}}
`;
const Track = styled.div`
  flex: 1; overflow: hidden;
  &:hover .move { animation-play-state: paused; }
`;
const Move = styled.div`
  display: inline-flex; align-items: center;
  animation: ${scroll} ${({ $dur }) => $dur}s linear infinite;
  will-change: transform;
`;
const Chip = styled.a`
  display: inline-flex; align-items: center; gap: .4rem; margin: 0 1.4rem;
  color: ${theme.colors.textSecondary}; text-decoration: none;
  &:hover b { color: ${theme.colors.primaryLight}; }
  b { color: #fff; font-weight: 700; }
  .ic { font-size: 1rem; }
  .tag { font-size: .6rem; font-weight: 800; color: ${theme.colors.primaryLight};
    background: rgba(124,58,237,.18); padding: .1rem .45rem; border-radius: 999px; }
`;

export default function NewsTicker() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => fetchNews().then((n) => { if (alive) setItems(n); }).catch(() => {});
    load();
    const t = setInterval(load, 120000); // rafraîchit toutes les 2 min
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!items || items.length === 0) return null;

  // durée proportionnelle au contenu (lecture confortable) ; on double la liste pour une boucle continue
  const dur = Math.max(24, items.length * 7);
  const loop = [...items, ...items];

  return (
    <Bar role="region" aria-label="Actualités VertinGo">
      <Label><span className="dot" /> News</Label>
      <Track>
        <Move className="move" $dur={dur}>
          {loop.map((it, i) => (
            <Chip key={i} href={cleanUrl(it.url)} target={cleanUrl(it.url) ? '_blank' : undefined} rel="noreferrer">
              <span className="ic">{it.icon || '📣'}</span>
              {it.tag && <span className="tag">{it.tag}</span>}
              <span><b>{it.title}</b>{it.text ? ` — ${it.text}` : ''}</span>
            </Chip>
          ))}
        </Move>
      </Track>
    </Bar>
  );
}
